import VPagination from './index.vue';

export default {
  install: (Vue) => Vue.component('VPagination', VPagination),
};
